import { hookManagerFactory } from './hooks';

const hookType = 'preCreateHook';

export const preCreateHookManager = hookManagerFactory({
  hookType,
})